import DropdownList from '@/components/DropdownList';

const Consideration = () => {
  const CONSIDERATION = `꼭 확인하세요!
∙ 해당 이벤트의 경품인 Google AI Pro 3개월 무료 체험권은 아래 조건을 충족한 고객에 한해 지급됩니다.
  ㄴ 익시오 가입 후 개인정보 수집 및 이용에 동의한 고객
  ㄴ 2025년 6월 2일(월)부터 2025년 8월 31일(일)까지 본 이벤트에 참여한 고객
∙ 이벤트는 휴대전화 번호 하나당 한 번만 참여가 가능합니다.
∙ 쿠폰은 선착순으로 지급되며 수량이 모두 소진될 경우 이벤트는 조기 종료될 수 있습니다.
∙ 쿠폰은 이벤트 신청한 날의 다음 주 화요일에 익시오에 가입한 핸드폰 번호로 문자 발송됩니다.
∙ 쿠폰 사용은 문자에 기재된 링크에 접속하여 결제 수단을 등록한 뒤 사용 가능합니다. (결제 수단이 이미 등록된 경우 바로 사용이 가능합니다.)
∙ 쿠폰 등록은 2025년 9월 30일(화)까지 가능합니다.
∙ 쿠폰은 이전에 Google AI Pro(이전 상품명 : AI Premium) 무료 체험권을 사용한 적이 없는 계정에 등록 가능합니다. (타사에서 제공 받았더라도 이미 무료 체험 쿠폰을 사용했다면 추가로 등록되지 않습니다.)
∙ 현재 Google One 유료 요금제를 쓰고 있는 경우 무료 체험 쿠폰을 등록하면 가입된 유료 요금제는 즉시 해지되고 남은 기간에 대한 금액이 자동 환불됩니다. 이후 쿠폰으로 등록한 Google AI Pro 3개월 무료 이용이 바로 시작됩니다.
∙ Google AI Pro 무료 체험 종료 전 유료 전환 여부를 묻는 메일이 Google One에 등록한 계정으로 발송됩니다. 유료 전환에 동의하지 않으면 체험 종료일에 자동으로 구독 취소되며 별도 과금은 되지 않습니다.
∙ 쿠폰은 중복 등록이 불가하며 계정에 오등록시에도 재발급해 드리지 않습니다.
∙ 해당 이벤트는 당사 사정에 따라 별도 안내 없이 조기 종료될 수 있습니다.`;

  return (
    <DropdownList title="유의 사항">
      <DropdownList.Text value={CONSIDERATION} />
    </DropdownList>
  );
};

export default Consideration;
